<template>
    <b-modal size="xl" button-size="sm" @hidden="close" @close="close" hide-footer v-model="showModal"
        :title="prefix + title">
        <b-card no-body>
            <b-card-body>
                <b-card bg-variant="light">
                    <b-form-row @keyup.enter="load" class="align-items-center">
                        <b-col lg="2" sm="12">
                            <lg-form-const-select label="Situação:" @change="load" v-model="form.situacao"
                                :options="form.optionsFilterSituacao" />
                        </b-col>
                        <b-col lg="6" sm="12">
                            <lg-form-input v-model="form.descricao" label="Descrição:" />
                        </b-col>
                        <b-col lg="2" sm="12" class="d-flex justify-content-end align-items-center">
                            <b-button id="limparOrnograma" class="my-2" size="sm" style="height: 20px" pill
                                variant="primary" @click="limparOrnograma">
                                <div class="btn-size-alinhamento">
                                    <b-icon icon="eraser" />
                                </div>
                                <b-tooltip target="limparOrnograma" title="Limpar"></b-tooltip>
                            </b-button>
                            <b-button id="localizarOrnograma" class="mr-2 my-2" size="sm" style="height: 20px" pill
                                variant="primary" @click="load()">
                                <div class="btn-size-alinhamento">
                                    <b-icon icon="search" /> &nbsp;
                                </div>
                                <b-tooltip target="localizarOrnograma" title="Localizar"></b-tooltip>
                            </b-button>
                        </b-col>
                    </b-form-row>
                </b-card>
                <div class="selecionar-todos">
                    <b-form-checkbox v-model="selecionarTodos" @change="toggleSelecionarTodos">
                        Selecionar Todos
                    </b-form-checkbox>
                    <span class="quantidade-selecionada">Selecionados: {{ departamentosSelecionados.length }}</span>
                </div>
                <b-card bg-variant="light" style="padding: 0; overflow: hidden;">
                    <div v-if="busy" class="text-center my-3">
                        <b-spinner small /> Carregando...
                    </div>
                    <div v-else ref="scrollContainer" class="hierarchy"
                        style="max-height: 500px; overflow-y: auto; padding: 15px; position: relative;" :key="treeKey"
                        @dragover.prevent="handleDragOver" @drop="onDropRoot">
                        <div class="root-dropzone">
                            Arraste itens aqui para torná-los independentes
                        </div>
                        <TreeItem @selecionar="selecionar" @change-hierarchy="atualizarHierarquia" v-for="pai in pais"
                            :key="pai.id" :node="pai" :recordsTree="records" />
                    </div>
                </b-card>
                <b-form-row>
                    <b-col cols="3"></b-col>
                    <b-col cols="6" class="text-center">
                        <b-button id="salvarOrnograma" class=" my-2" size="sm" pill variant="success"
                            @click="selecionarOrnograma">
                            <b-icon icon="check-circle" />
                            <b-tooltip target="salvarOrnograma" title="Salvar"></b-tooltip>
                        </b-button>
                        <b-button id="cancelarOrnograma" class=" my-2 ml-2" size="sm" pill variant="danger"
                            @click="close">
                            <b-icon icon="x-circle" />
                            <b-tooltip target="cancelarOrnograma" title="Cancelar"></b-tooltip>
                        </b-button>
                    </b-col>
                    <b-col cols="3"></b-col>
                </b-form-row>
            </b-card-body>
        </b-card>
    </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import ConfirmMixin from "@/core/mixins/confirm";
import { ListResourceMixin } from "@/core/mixins/resource";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import TreeItem from "./TreeItem.vue";

export default {
    components: {
        LgFormInput,
        LgFormConstSelect,
        TreeItem,
    },
    mixins: [ConfirmMixin, ListResourceMixin],
    props: {
        id: String,
        codsDepartamentos: {
            type: String,
            default: "",
        },
        prefix: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            treeKey: 0,
            selecionarTodos: false,
            departamentosSelecionados: [],
            showModal: true,
            title: "Organograma de Unidades Administrativas",
            busy: false,
            form: {
                descricao: "",
                situacao: 1,
                optionsFilterSituacao: [
                    { value: null, text: "Todos" },
                    { value: 1, text: "Ativo" },
                    { value: 0, text: "Inativo" },
                ],
            },
            scrollInterval: null
        };
    },
    computed: {
        pais() {
            return this.records.filter(dep => !dep.codDepartamentoSuperior);
        },
    },
    methods: {
        handleDragOver(event) {
            const container = this.$refs.scrollContainer;
            if (!container) return;
            const rect = container.getBoundingClientRect();
            const offset = event.clientY - rect.top;
            clearInterval(this.scrollInterval);
            if (offset < 50) {
                this.scrollInterval = setInterval(() => { container.scrollTop -= 15; }, 20);
            } else if (offset > rect.height - 50) {
                this.scrollInterval = setInterval(() => { container.scrollTop += 15; }, 20);
            }
        },
        onDropRoot(event) {
            clearInterval(this.scrollInterval);
            const draggedId = event.dataTransfer.getData('nodeId');
            if (draggedId) {
                this.atualizarHierarquia({ draggedId: Number(draggedId), targetId: null });
            }
        },
        isDescendant(parentId, childId) {
            let current = this.records.find(r => r.id === childId);
            while (current && current.codDepartamentoSuperior !== null) {
                if (current.codDepartamentoSuperior === parentId) return true;
                current = this.records.find(r => r.id === current.codDepartamentoSuperior);
            }
            return false;
        },
        atualizarHierarquia({ draggedId, targetId }) {
            draggedId = Number(draggedId);
            targetId = targetId !== null ? Number(targetId) : null;
            if (draggedId === targetId) return;
            if (targetId !== null && this.isDescendant(draggedId, targetId)) return;
            const index = this.records.findIndex(r => r.id === draggedId);
            if (index !== -1) {
                let node = this.records[index];
                node.codDepartamentoSuperior = targetId;
                this.$set(this.records, index, { ...node });
                if (targetId) {
                    this.$service.put(targetId + "/" + node.id);
                } else {
                    this.$service.put("0/" + node.id);
                }
                this.mapaDepartamentos = this.prepararMapaDepartamentos(this.records);
                this.treeKey++;
            }
        },
        selecionarOrnograma() {
            this.$emit("selecionarOrnograma", this.departamentosSelecionados);
            this.close();
        },
        toggleSelecionarTodos() {
            this.busy = true;
            if (this.selecionarTodos) {
                this.departamentosSelecionados = [...this.records];
                this.records.forEach(record => record.selecionado = true);
            } else {
                this.departamentosSelecionados = [];
                this.records.forEach(record => record.selecionado = false);
            }
            this.busy = false;
        },
        prepararMapaDepartamentos(lista) {
            let mapa = new Map();
            lista.forEach(item => {
                mapa.set(item.id, { ...item, filhos: [] });
            });
            lista.forEach(item => {
                if (item.codDepartamentoSuperior !== null && mapa.has(item.codDepartamentoSuperior)) {
                    mapa.get(item.codDepartamentoSuperior).filhos.push(mapa.get(item.id));
                }
            });
            return mapa;
        },
        getTodosOsFilhos(id, mapa) {
            if (!mapa.has(id)) return [];
            let resultado = [];
            let stack = [mapa.get(id)];
            while (stack.length) {
                let no = stack.pop();
                resultado.push(no);
                stack.push(...no.filhos);
            }
            return resultado;
        },
        selecionar(node) {
            if (!this.mapaDepartamentos || !this.mapaDepartamentos.has(node.id)) return;
            this.busy = true;
            let id = node.id;
            let selecionado = node.selecionado;
            let filhos = this.getTodosOsFilhos(id, this.mapaDepartamentos);
            let idsFilhos = new Set(filhos.map(f => f.id));
            if (selecionado) {
                filhos.forEach(filho => {
                    if (!this.departamentosSelecionados.some(sel => sel.id === filho.id)) {
                        this.departamentosSelecionados.push(filho);
                    }
                });
            } else {
                this.departamentosSelecionados = this.departamentosSelecionados.filter(sel => !idsFilhos.has(sel.id));
            }
            let selecionados = new Set(this.departamentosSelecionados.map(item => item.id));
            this.records.forEach(record => record.selecionado = selecionados.has(record.id));
            this.busy = false;
        },
        async load() {
            this.busy = true;
            this.filtro = {};
            if (this.form.descricao) {
                this.filtro.descricao = this.form.descricao;
            }
            if (this.form.situacao !== null) {
                this.filtro.situacao = this.form.situacao;
            }
            await this.$loadResource({ params: this.filtro });
            this.mapaDepartamentos = this.prepararMapaDepartamentos(this.records);
            this.departamentosSelecionados = [];
            this.treeKey++;
            this.busy = false;
        },
        limparOrnograma() {
            this.form.situacao = null;
            this.form.descricao = "";
            this.load();
        },
        close() {
            clearInterval(this.scrollInterval);
            this.$emit("close");
        },
    },
    async beforeMount() {
        this.$service = new ResourceService("/api/departamentos/hierarquia");
        await this.load();
        if (this.codsDepartamentos != "") {
            this.busy = true;
            var ids = this.codsDepartamentos.split(",").map(id => Number(id.trim()));
            this.records.forEach(record => {
                if (ids.includes(record.id)) {
                    record.selecionado = true;
                    this.departamentosSelecionados.push(record);
                }
            });
            this.busy = false;
        }
    },
};
</script>

<style scoped>
.hierarchy {
    margin-top: 10px;
    min-height: 100px;
}

.root-dropzone {
    padding: 15px;
    margin-bottom: 15px;
    border: 2px dashed #007bff;
    text-align: center;
    color: #007bff;
    background-color: #f0f7ff;
    border-radius: 8px;
    font-weight: bold;
    position: sticky;
    top: 0;
    z-index: 10;
}

.selecionar-todos {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    background: #f8f9fa;
    border-bottom: 1px solid #ddd;
}

.quantidade-selecionada {
    font-weight: bold;
    color: #007bff;
}
</style>